import { Logger } from "$lib/core";

const logger = new Logger("InfoBox");

export default class InfoBox extends HTMLElement {
	static get observedAttributes() {
		return ["type", "icon"];
	}

	constructor() {
		super();
		this.type = "info";
		this.icon = null;
	}

	connectedCallback() {
		this.icon = this.icon ?? this.#iconFromType();
		this.render();
		this.remove();
	}

	/**
	 * @param {string} name 
	 * @param {string} oldValue 
	 * @param {string} newValue 
	 */
	attributeChangedCallback(name, oldValue, newValue) {
		if (name === "type") {
			this.type = newValue;
		} else if (name === "icon") {
			this.icon = newValue;
		}
	}

	#iconFromType() {
		const t = this.type ?? "info";
		switch (t) {
			case "info": return "fa-regular fa-circle-info";
			case "success": return "fa-regular fa-circle-check";
			case "danger": return "fa-solid fa-octagon-exclamation";
			case "warning": return "fa-regular fa-warning";
		}
	}

	get classes() {
		const classes = new Set();
		classes.add("infobox");
		for (let token of this.classList) {
			classes.add(token);
		}
		if (this.type) {
			classes.add(this.type);
		}
		return [...classes].join(' ');
	}

	render(args = {}) {
		logger.debug("rendering InfoBox", {
			classes: this.classes,
			icon: this.icon,
			html: this.innerHTML,
		});
		this.insertAdjacentHTML("afterend", `
			<p class="${this.classes}">
				<span><i class="${this.icon}"></i></span>
				<span>${this.innerHTML}</span>
			</p>
		`);
	}
}

Logger.addLogger("InfoBox");